import React, { useState } from 'react';
import { Popover, ButtonBase } from '@mui/material';

import * as styles from './HighlightedPopover.module.css';

const HighlightedPopover = ({ prefix, shortText, onOpenText }) => {
  const [target, setTarget] = useState();
  const idOp = 'popover' + prefix + shortText;

  return (
    <div>
      <ButtonBase
        className={styles.highlightedBtn}
        aria-describedby={idOp}
        variant="contained"
        color="primary"
        onClick={(event) => {
          setTarget(event.currentTarget);
        }}
      >
        {prefix}: {shortText}
      </ButtonBase>
      <Popover
        idOp={idOp}
        open={!!target}
        anchorEl={target}
        onClose={() => {
          setTarget();
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <div
          style={{ padding: 8 }}
          dangerouslySetInnerHTML={{
            __html: onOpenText,
          }}
        />
      </Popover>
    </div>
  );
};
export default HighlightedPopover;
